// @flow
import React from "react";
import {
    type CardItemResultDTO,
    type CardItemDTO,
    type CardTypeEnum,
} from "data/types";
import { connect, Dispatch } from "react-redux";
import Constants, { type ConstantsEnum } from "data/constants";
import ArchiveTargetCards from "./ArchiveTargetCards";
import { getCardsAction } from "data/actions";
import * as s from "data/reducers/selectors";

type Props = {
    /** which card type to show - CardType.Rec or CardType.Fav */
    cardType: CardTypeEnum,
    /** current ArchiveTarget */
    archiveTarget: CardItemResultDTO,
    /** callback when user selects a Recent card */
    onClick: (card: CardItemDTO) => void,
    /** callback when user clicks Cancel */
    onCancel: () => void,
    /** Redux home cards loading status */
    status: ConstantsEnum,
    /** Redux home cards */
    cards: Array<CardItemDTO>,
    /** Redux dispatch */
    dispatch: Dispatch,
};

export const ArchiveTargetHomeCards = ({
    cardType,
    archiveTarget,
    onClick,
    onCancel,
    status,
    cards,
    dispatch,
}: Props) => {
    if (status === Constants.NONE) {
        dispatch(getCardsAction());
    }
    return (
        <ArchiveTargetCards
            archiveTarget={archiveTarget}
            status={status}
            cardType={cardType}
            cards={cards}
            onClick={onClick}
            onCancel={onCancel}
        />
    );
};
ArchiveTargetHomeCards.displayName = "ArchiveTargetHomeCards";

const mapStateToProps = /* istanbul ignore next */ (state, ownProps) => ({
    status: s.cardsStatusSelector(state),
    cards: s.cardsCardsSelector(state) || [],
    ...ownProps,
});
export default connect(mapStateToProps)(ArchiveTargetHomeCards);
